window.ScreenXS = 580;
window.ScreenSM = 768;
window.ScreenMD = 1020;
window.ScreenLG = 1260;
window.ScreenXL = 1400;
